import { render } from "./PostComp.vue?vue&type=template&id=75490f36"
import script from "./PostComp.vue?vue&type=script&lang=js"
export * from "./PostComp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__